import React from "react";
import { Button, ListGroupItem } from "react-bootstrap";
import "./FacebookFriend.css";

export default class FacebookFriend extends React.Component {
  render() {
    const friend = this.props.src;

    return (
      <ListGroupItem
        className="text-primary Friend responsive"
        key={friend.id}
        onClick={this.props.onClick}
        tag="div"
      >
        <table>
          <tbody>
            <tr>
              <td>
                <div>
                  <img
                    src={friend.picture.data.url}
                    alt={friend.name}
                    className="img-rounded img-responsive pull-left "
                  />
                  {friend.name}
                </div>
              </td>
              <td align="right">
                <Button
                  className="floating"
                  bsStyle="primary"
                  onClick={this.props.onFriendRequest}
                >
                  Request Connection
                </Button>
              </td>
            </tr>
          </tbody>
        </table>
      </ListGroupItem>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FacebookFriend.js